function getTrackingMinutes(user) {
  if (!user.organizations || user.organizations.length === 0) {
    return 0
  }

  return user.organizations.reduce((acc, v) => {
    if (v.organization && v.organization.tracking_minutes) {
      if (v.organization.tracking_minutes === -1) {
        return -1
      }

      return acc + v.organization.tracking_minutes
    }

    return acc
  }, 0)
}

export default getTrackingMinutes
